import CT from '@marketplace-ai/tags';
import { FormCell, FormSection, FormRow as Row, Select, TextInput } from '~/components';
import { ADDRESS_TYPE_OPTIONS, COUNTRIES, STATES } from '~/constants';

const TAGS = CT.profile.contactInfo.address.form;

export const AddressForm = () => {
  return (
    <FormSection componentsPerLine={1}>
      <FormCell span={6}>
        <Row>
          <Select
            name={'addressType'}
            label={'Address Type'}
            cyTag={TAGS.typeSelect}
            options={ADDRESS_TYPE_OPTIONS}
          />
        </Row>
      </FormCell>
      <FormCell span={6}>
        <Row>
          <Select
            name={'countryCode'}
            label={'Country'}
            cyTag={TAGS.countrySelect}
            options={COUNTRIES}
          />
        </Row>
      </FormCell>
      <FormCell span={12}>
        <Row>
          <TextInput
            label={'Address Line 1'}
            name={'addressLine1'}
            autoComplete={'street address address-line1'}
            placeholder="Street Address..."
            cyTag={TAGS.line1Input}
          />
        </Row>
      </FormCell>
      <FormCell span={12}>
        <Row>
          <TextInput
            label={'Address Line 2'}
            name={'addressLine2'}
            autoComplete={'street address address-line2'}
            cyTag={TAGS.line2Input}
          />
        </Row>
      </FormCell>
      <FormCell span={6}>
        <Row>
          <TextInput
            label={'City'}
            name={'city'}
            autoComplete={'city'}
            placeholder="City"
            cyTag={TAGS.cityInput}
          />
        </Row>
      </FormCell>
      <FormCell span={3}>
        <Row>
          <Select name={'stateCode'} label={'State'} cyTag={TAGS.stateSelect} options={STATES} />
        </Row>
      </FormCell>
      <FormCell span={3}>
        <Row>
          <TextInput name={'postalCode'} cyTag={TAGS.postalCodeInput} label={'Postal Code'} />
        </Row>
      </FormCell>
    </FormSection>
  );
};
